<script setup>
import AppSidebar from '../components/AppSidebar.vue'
import { ref, onMounted, onBeforeUnmount } from 'vue'
import alert from '@/utils/alert'
import { useRouter } from 'vue-router'

const router = useRouter()

// Ambil token
const token = localStorage.getItem('token')
if (!token) {
  alert.error('Unauthorized!')
  router.push('/')
}

// Jam dan tanggal
const currentDateTime = ref('')
const updateDateTime = () => {
  const now = new Date()

  const tanggal = now.toLocaleDateString('id-ID', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })

  const jam = now.toLocaleTimeString('id-ID', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })

  currentDateTime.value = `${tanggal}, ${jam}`
}

let interval = null
onMounted(() => {
  updateDateTime()
  interval = setInterval(updateDateTime, 1000)
})

onBeforeUnmount(() => {
  clearInterval(interval)
})

// Fungsi navigasi ubah password
const goChangePassword = () => {
  router.push('/ubahpassword') // pastikan route ini sudah ada
}
</script>

<template>
  <div class="wrapper">
    <!-- Navbar -->
    <nav class="main-header navbar navbar-expand navbar-white navbar-light shadow-sm">
      <!-- Kiri -->
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" data-widget="pushmenu" href="#"><i class="fas fa-bars"></i></a>
        </li>
        <li class="nav-item d-none d-sm-inline-block">
          <router-link to="/" class="nav-link">Dashboard</router-link>
        </li>
      </ul>

      <!-- Kanan -->
      <ul class="navbar-nav ms-auto align-items-center">
        <!-- Jam -->
        <li class="nav-item me-3 d-flex align-items-center">
          <span style="font-size: small">{{ currentDateTime }}</span>
        </li>

        <!-- Link Ubah Password -->
        <li class="nav-item">
          <button @click="goChangePassword" class="btn btn-sm btn-outline-primary">
            <i class="fas fa-key me-1"></i> Ubah Password
          </button>
        </li>
      </ul>
    </nav>

    <!-- Sidebar -->
    <AppSidebar />

    <!-- Content -->
    <div class="content-wrapper p-3">
      <slot />
    </div>

    <!-- Footer -->
    <footer class="main-footer text-center py-3 border-top">
      <strong>Metatek &copy; 2025</strong>
    </footer>
  </div>
</template>

<style scoped>
.wrapper {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

.content-wrapper {
  flex: 1;
  background-color: #f8f9fa;
  min-height: calc(100vh - 112px); /* navbar + footer height */
}

.main-footer {
  background-color: #fff;
}

.navbar .btn {
  font-size: 0.85rem;
}
</style>
